import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SuccessContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: "400px",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech",

    "@media (max-width: 600px)": {
        width: "100%",
    },
}));

export const StyledBlueSpan = styled("span")(({ theme }) => ({
    color: theme.colors["blue.400"]
}));

export const TitleContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._500,
    alignSelf: "strech",
}));

export const ImageContainer = styled("div")(({ theme }) => ({
    display: "flex",
    position: "relative",
    alignItems: "center",
    alignSelf: "strech",
    aspectRatio: 2.14,
    width:"100%",
    maxWidth:"338px",
    height: "auto",
}));

export const SuccessImage = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    position: "relative",
    width: theme.space._1250,
    height: theme.space._1100
}));

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
}));

export const ContentTitle = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["2xl"],
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.500"],
    textAlign: "center",
    fontSize: theme.fontSizes["md"],
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.tall,
}));

export const EndingPhrase = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.500"],
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base, 
}));

export const ContentContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech",
}));

export const CTAContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech",
}));
